export enum IntegrationPageTrackingIds {
  TREE_VIEW = 'tree_view',
  BLOCKS = 'blocks',
}
